import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var StarFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.404 19.02-11.123 8.794 3.908 13.59c.401 1.4-1.202 2.499-2.405 1.8L21.96 35.308l-11.824 7.794c-1.203.9-2.706-.3-2.305-1.699l3.808-13.59L.615 19.02c-1.203-.899-.501-2.798.902-2.798l14.13-.6 4.81-13.19c.5-1.399 2.505-1.299 3.006 0l4.91 13.19 14.13.6c1.503.1 2.004 1.899.901 2.798Z"
  }));
});
StarFill.displayName = 'StarFill';
StarFill.defaultProps = {
  'aria-label': 'StarFill'
};
export default StarFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/StarFill.js
// module id = 3291
// module chunks = 11